import React, { useState, useEffect } from "react"; // Import useState and useEffect

import logo from "./logo.svg";
import "./App.css";
import "./index.css";

import Login from "./Users/Login";
import Signup from "./Users/Signup";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useNavigate,
} from "react-router-dom";
import { ConfigProvider } from "antd"; // Import ConfigProvider
import ForgetPassword from "./Users/ForgetPassword";
import ResetPassword from "./Users/ResetPassword";
import PageLayout from "./Components/layout/PageLayout";
import SignUpwithGoogle from "./Users/SignUpwithGoogle";
import Dashboard from "./Components/Dashboard";
// import Pagerouter from './Routing/ProtectedRoute';
import Notes from "./Pages/Notes";
import MyProfile from "./Users/MyProfile";
import Calender from "./Pages/Calender";
import Members from "./Pages/Members";
import EmailListing from "./Pages/EmailListing";

import AddTask from "./Pages/CalenderModal/AddTask";
import ProtectedRoute from "./Routing/ProtectedRoute"; // Import Protected Route
import ImageTest from "./Pages/ImageTest";
import InviteCapture from "./Pages/InviteCapture/InviteCapture";
import CaptureInvitations from "./Pages/InviteCapture/CaptureInvitations";
import AddCoPreant from "./Pages/CoParent/AddCoParent";
import CoParentCalender from "./Pages/CoParent/CoParentCalender";
import AddCoParent from "./Pages/CoParent/AddCoParent";
import PublicRoute from "./Routing/PublicRoute";
import SubscriptionPlans from "./Components/Modals/SubscriptionModal/subscriptionPlan";
import FeatureGuard from "./Components/FeatureGuard";
import InviteHandler from "./Components/InviteHandler";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!localStorage.getItem("authToken")
  );

  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem("authToken");
      setIsAuthenticated(!!token);
    };

    window.addEventListener("storage", checkAuth); // Listen for token changes
    return () => window.removeEventListener("storage", checkAuth);
  }, []);

  return (
    <div>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: "#9A4FE0", // Change primary color
            borderRadius: 6, // Change border radius
            fontSize: 16, // Change font size
          },
          components: {
            Button: {
              colorText: "#ffffff", // Change default text color
              colorBorder: "#9A4FE0", // Change border color
              colorBgContainer: "#9A4FE0", // Background color
              colorTextHover: "#9A4FE0", // Text color on hover
              colorBgContainerHover: "transparent",
            },
            Input: {
              activeBorderColor: "#9A4FE0",
            },
          },
        }}
      >
        <Router>
          <InviteHandler />
          <Routes>
            <Route path="/pricing" element={<SubscriptionPlans />} />
            <Route element={<PublicRoute />}>
              <Route path="/" element={<Login />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/forgetpassword/" element={<ForgetPassword />} />
              <Route
                path="/reset-password/:token"
                element={<ResetPassword />}
              />
              <Route path="/signupwithgoogle" element={<SignUpwithGoogle />} />
            </Route>

            <Route element={<ProtectedRoute />}>
              <Route element={<PageLayout />}>
                {/* ⬅️ WRAP inside PageLayout */}
                <Route path="/dashboard" element={<Dashboard />} />
                <Route
                  path="/calender"
                  element={
                    <FeatureGuard
                      requiredFeature={
                        "Personal Event Reminders & Notes (MVP version)"
                      }
                    >
                      <Calender />
                    </FeatureGuard>
                  }
                />
                <Route
                  path="/members"
                  element={
                    <FeatureGuard
                      requiredFeature={
                        "Shared Calendar with Children/Relatives"
                      }
                    >
                      <Members />
                    </FeatureGuard>
                  }
                />
                <Route path="/addtask" element={<AddTask />} />
                <Route
                  path="/notes"
                  element={
                    <FeatureGuard requiredFeature="Shared Notes & Notifications">
                      <Notes />
                    </FeatureGuard>
                  }
                />
                <Route path="/profile" element={<MyProfile />} />
                <Route
                  path="/EmailListing"
                  element={
                    <FeatureGuard
                      requiredFeature={"AI-Powered Email Assistant"}
                    >
                      <EmailListing />
                    </FeatureGuard>
                  }
                />
                <Route path="/image-test" element={<ImageTest />} />

                <Route
                  path="/invite-capture"
                  element={
                    <FeatureGuard
                      requiredFeature={"Invite Capture (photo/PDF to calendar)"}
                    >
                      <CaptureInvitations />
                    </FeatureGuard>
                  }
                />
                <Route
                  path="/co-parent"
                  element={
                    <FeatureGuard
                      requiredFeatures={[
                        "Co-Parenting Calendar (shared child \narrangement tools)",
                        "Co-Parent Privacy & Access Settings",
                      ]}
                    >
                      <AddCoParent />
                    </FeatureGuard>
                  }
                />
                <Route
                  path="/co-parent-calender"
                  element={<CoParentCalender />}
                />
              </Route>
            </Route>
          </Routes>
        </Router>
      </ConfigProvider>
    </div>
  );
}

export default App;
